import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '@core/models/general.model';
import { environment } from '@environments/environment';
import { UserAccount } from '@core/models/userAccount.model';

@Injectable({ providedIn: 'root' })
export class ProveedorService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiUrl;

  getEmpresas(userName: string): Observable<ApiResponse<UserAccount[]>> {
    const params = new HttpParams().set('userName', userName);
    return this.http.get<ApiResponse<UserAccount[]>>(
      `${this.apiUrl}/v1/proveedor/empresas`,
      { params },
    );
  }

  getInfoEmpresa(params: {
    userName: string;
    empresaId: number;
  }): Observable<ApiResponse<any>> {
    const httpParams = new HttpParams()
      .set('userName', params.userName)
      .set('empresaId', String(params.empresaId));

    return this.http.get<ApiResponse<any>>(
      `${this.apiUrl}/v1/proveedor/info-empresa`,
      { params: httpParams },
    );
  }

  getConsultaDefaultDespachos(params: {
    userName: string;
    empresaId: number;
  }): Observable<ApiResponse<any>> {
    const httpParams = new HttpParams()
      .set('userName', params.userName)
      .set('empresaId', String(params.empresaId));

    return this.http.get<ApiResponse<any>>(
      `${this.apiUrl}/v1/proveedor/consulta-default-despachos`,
      { params: httpParams },
    );
  }
}
